var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.996 7H12.005M4 10V18.5M8 10V18.5M16 10V18.5M20 10V18.5M2 8.57C2 7.373 2.482 6.64 3.48 6.084L7.59 3.797C9.743 2.6 10.82 2 12 2C13.18 2 14.257 2.6 16.41 3.797L20.52 6.084C21.517 6.64 22 7.373 22 8.57C22 8.894 22 9.057 21.965 9.19C21.779 9.89 21.144 10.001 20.531 10.001H3.469C2.856 10.001 2.222 9.891 2.035 9.19C2 9.056 2 8.894 2 8.57ZM19 18.5H5C4.20435 18.5 3.44129 18.8161 2.87868 19.3787C2.31607 19.9413 2 20.7044 2 21.5C2 21.6326 2.05268 21.7598 2.14645 21.8536C2.24021 21.9473 2.36739 22 2.5 22H21.5C21.6326 22 21.7598 21.9473 21.8536 21.8536C21.9473 21.7598 22 21.6326 22 21.5C22 20.7044 21.6839 19.9413 21.1213 19.3787C20.5587 18.8161 19.7956 18.5 19 18.5Z",
    stroke: "#22C55E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankGreen);
export default __webpack_public_path__ + "static/media/Bank Green.9f5db5523200466115e1936f9d9ca33c.svg";
export { ForwardRef as ReactComponent };